import React from "react";
import { FaSpinner } from "react-icons/fa";
import { numberWithCommas } from "../../service/utilService";

export default function ViolationsChargebackBlock(props) {
  const { Header, pendingData, dueData,loader } = props;

  return (
    <>
      <div className="violation_chargback-block ">
        <p className="block-title">{Header}</p>
        <br/>
        <div id="pending">
          <div>{Header} Pending</div>
          <div className="chargeback_data"> {loader ? <FaSpinner icon="spinner" spin className = "spinner-img widgets-spinner"/> : <>{numberWithCommas(pendingData || 0,0)} </>}</div>
        </div>
        <div id="due">
          <div>{Header} due in 60 mins</div>
          <div className="chargeback_data"> {loader ?  <FaSpinner icon="spinner" spin className = "spinner-img widgets-spinner"/> : <>{numberWithCommas(dueData || 0,0)} </>}</div>
        </div>
      </div>
    </>
  );
}
